import React, { useState } from 'react'
import { CircularProgress, Typography, withStyles } from '@material-ui/core'
import { Icon } from '@iconify/react'
import styles from './styles'
import clsx from 'clsx'
import { useDispatch, useSelector } from 'react-redux'
import { llmDeleteAttachmentAction } from 'src/reducers/llm/action'
import { track } from '@amplitude/analytics-browser'

const AttachmentView = props => {
  const {
    classes,
    attachments,
    handleOnDropFile,
    fileInputRef,
    handleFileSelect,
    attachmentLoading,
  } = props
  const [isHovered, setIsHovered] = useState(false)
  const [hoveredIconId, setHoveredIconId] = useState(null)
  const dispatch = useDispatch()
  const chatId = useSelector(state => state.llmContent.chatId)

  const handleDeleteAttachment = attachmentId => {
    track('delete_attachment')
    dispatch(llmDeleteAttachmentAction(chatId, attachmentId))
  }

  const onClickAttachment = () => {
    if (attachmentLoading) return
    fileInputRef.current.click()
  }

  return (
    <div className={classes.container}>
      <Typography className={classes.textDefault}>Uploaded Files</Typography>
      {attachments.map((attachment, index) => (
        <div key={index} className={classes.attachmentRow}>
          <Icon
            icon="lets-icons:file-fill"
            className={clsx(classes.fileIcon, {
              [classes.fileIconError]: !attachment.succeeded,
              [classes.fileIconSuccess]: attachment.succeeded,
            })}
          />
          <Typography className={classes.fileName}>
            {attachment.file_name}
          </Typography>
          <div className={classes.flexGrow} />
          {attachment.succeeded === false &&
          attachment.upload_status !== 'failed' &&
          attachment.upload_status !== 'partial_failure' &&
          !(attachment.error_details && attachment.error_details.length > 0) ? (
            <CircularProgress size="16px" color="primary" />
          ) : (
            <div
              onMouseEnter={() => setHoveredIconId(attachment.attachment_id)}
              onMouseLeave={() => setHoveredIconId(null)}
            >
              {hoveredIconId === attachment.attachment_id ||
              attachment.succeeded === false ? (
                <Icon
                  icon="iconamoon:close-light"
                  className={classes.closeIcon}
                  onClick={() =>
                    handleDeleteAttachment(attachment.attachment_id)
                  }
                />
              ) : (
                <Icon icon="charm:tick" className={classes.tickIcon} />
              )}
            </div>
          )}
        </div>
      ))}

      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onDrop={handleOnDropFile}
        onDragOver={e => e.preventDefault()}
        onClick={onClickAttachment}
        className={clsx({
          [classes.addMore]: !isHovered,
          [classes.addMoreHover]: isHovered,
        })}
      >
        {attachmentLoading ? (
          <CircularProgress size={20} />
        ) : (
          <>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              accept=".pdf, .txt"
              onChange={handleFileSelect}
            />
            <Icon
              icon="f7:cloud-upload"
              className={clsx({
                [classes.uploadIconDefault]: !isHovered,
                [classes.uploadIconHover]: isHovered,
              })}
            />
            <Typography
              className={clsx({
                [classes.textDefault]: !isHovered,
                [classes.textHover]: isHovered,
              })}
            >
              Upload more
            </Typography>
            <div className={classes.flexGrow} />
            <Icon
              icon="uil:plus"
              className={clsx({
                [classes.uploadIconDefault]: !isHovered,
                [classes.uploadIconHover]: isHovered,
              })}
            />
          </>
        )}
      </div>
    </div>
  )
}

export default withStyles(styles)(AttachmentView)
